export default __webpack_public_path__ + "static/media/Tier1.7fb768cd.svg";